module.exports = {
	"classes": [
		"guest-authors-page"
	],
	"title": "Auth0's Guest Author Program",
	"metas": {
		"description": "Do you love learning new technologies and writing tutorials on how to use them? Want to get paid and have your content pushed to a wide audience? Join us!"
	},
	"opengraph": {
		"og:title": "Auth0's Guest Author Program",
		"og:description": "Do you love learning new technologies and writing tutorials on how to use them? Want to get paid and have your content pushed to a wide audience? Join us!",
		"og:url": "https://auth0.com/guest-authors",
		"og:image": "http://cdn2.auth0.com/blog/guest-authors/twitter-card-2.png ",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/guest-authors/twitter-card-2.png"
	},
	"twittercard": {
		"twitter:title": "Auth0's Guest Author Program",
		"twitter:description": "Do you love learning new technologies and writing tutorials on how to use them? Want to get paid and have your content pushed to a wide audience? Join us!",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/guest-authors/twitter-card-2.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/guest-authors/metadata.json
// module id = 1122
// module chunks = 0